import React from 'react'
import { useIntl } from 'react-intl'
import styled from 'styled-components'
import { rem } from 'polished'
import { mediaQueryUp } from 'components/utils/breakpoint'
import LayoutContainer from 'components/Common/LayoutContainer'
import Group from 'components/utils/Group'
import HeadingTextBlock from 'LuxKit/TextBlocks/HeadingTextBlock'
import BodyTextBlock from 'LuxKit/TextBlocks/BodyTextBlock'
import LuxPlusSubscriptionTsAndCs from '../LuxPlusSubscriptionTsAndCs'
import useLuxPlusBenefitsView from 'luxPlus/hooks/useLuxPlusBenefitsView'
import { LUXURY_PLUS } from 'luxPlus/constants/base'
import LuxPlusLandingBenefitTileItem from './LuxPlusLandingBenefitTileItem'
import LuxPlusRenewalBonusBenefitTile from './LuxPlusRenewalBonusBenefitTile'
import LuxPlusLandingCtaButtons from './LuxPlusLandingCtaButtons'

const SectionWrapper = styled.div`
  padding: ${rem(40)} 0;
  background-color: ${props => props.theme.palette.neutral.surface.lightBackground};

  ${mediaQueryUp.tablet} {
    padding: ${rem(60)} 0;
  }
`

const BenefitsGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  row-gap: ${rem(12)};
  column-gap: ${rem(28)};
  width: 100%;

  ${mediaQueryUp.tablet} {
    grid-template-columns: 1fr 1fr;
  }
`

function LuxPlusLandingBenefitsList() {
  const intl = useIntl()
  const visibleBenefits = useLuxPlusBenefitsView()

  if (!visibleBenefits.length) return null

  const becomeMemberLabel = intl.formatMessage({
    id: '6ajbFZSXd33DczR2endE',
    defaultMessage: 'Become a member',
    description: 'CTA button to join LuxPlus on benefits list section',
  })

  const startFreePreviewLabel = intl.formatMessage({
    id: 'di7K46pwDVuApxrcDjdX',
    defaultMessage: 'Start 28-day free preview',
    description: 'CTA button to start free preview on benefits list section',
  })

  return (
    <SectionWrapper>
      <LayoutContainer>
        <Group direction="vertical" gap={24} horizontalAlign="center">
          <Group direction="vertical" gap={8} horizontalAlign="center">
            <HeadingTextBlock variant="heading2" align="center">
              {intl.formatMessage(
                {
                  id: 'F4MY7V4P98bzK-DGH1a7',
                  defaultMessage: '{programName} benefits',
                  description: 'Heading for the LuxPlus benefits list section on landing page',
                },
                { programName: LUXURY_PLUS.PROGRAM_NAME },
              )}
            </HeadingTextBlock>
            <BodyTextBlock variant="large" colour="normal-contrast" align="center">
              {intl.formatMessage(
                {
                  id: 'W9_MSc0sA2-pjvswxGKk',
                  defaultMessage: 'All the ways {programName} helps you save and travel better',
                  description: 'Subheading for the LuxPlus benefits list section on landing page',
                },
                { programName: LUXURY_PLUS.PROGRAM_NAME },
              )}
            </BodyTextBlock>
          </Group>

          <BenefitsGrid>
            {visibleBenefits.map(benefit => (
              <LuxPlusLandingBenefitTileItem
                key={benefit.type}
                benefit={benefit}
              />
            ))}
            <LuxPlusRenewalBonusBenefitTile />
          </BenefitsGrid>

          <LuxPlusLandingCtaButtons
            becomeMemberLabel={becomeMemberLabel}
            startFreePreviewLabel={startFreePreviewLabel}
            gap={12}
            horizontalAlign="center"
            normalFooter={<LuxPlusSubscriptionTsAndCs />}
            switchRegionLogoColour="inherit"
          />
        </Group>
      </LayoutContainer>
    </SectionWrapper>
  )
}

export default LuxPlusLandingBenefitsList
